import React, { useEffect } from 'react';
import './ContestProgress.css'
import { useContext } from 'react';
import AdminContext from '../context/AdminContext';

export default function ContestProgress(props) {
    useEffect(() => {
        return (() => {
        })
    }, []);

    var context = useContext(AdminContext)

    function progressClass(lineItem) {
        if (lineItem > props.status) return '';
        if (lineItem === props.status) return 'current';
        return 'visited';
    }

    return (

        <ol className="cd-multi-steps text-bottom count">
            <li className={progressClass(1)}><em>New</em></li>
            <li className={progressClass(2)}><em>Displayed</em></li>
            <li className={progressClass(3)}><em>Opened</em></li>
            <li className={progressClass(4)}><em>Paused</em></li>
            <li className={progressClass(5)}><em>Closed</em></li>
            {context.switches.hybrid &&
                <li className={progressClass(6)}><em>Finalised</em></li>
            }
            <li className={progressClass(7)}><em>Published</em></li>
        </ol>
    )
}